<div class="mx-auto flex w-full max-w-[1920px] flex-col gap-8 p-8">
    <div class="flex flex-col gap-4">
        <div class="flex justify-between">
            <h2 class="m-0 select-none text-[32px] text-[var(--logo-1)]">{{ 'user-management.title' | translate }}</h2>
        </div>
        <div class="flex items-center justify-between gap-4">
            <div class="flex w-96 flex-col gap-2">
                <sh-input-text [label]="'user-management.search' | translate" [formControl]="searchControl" />
            </div>

            <sh-button
                (click)="openAddUserDialog($event)"
                color="primary"
                size="max-content"
                ariaLabel="Open add user dialog"
                [label]="'user-management.buttons.add' | translate"
            />
        </div>
    </div>
    <div>
        <ng-container>
            @if (isLoading() || users().length > 0) {
                <div class="flex select-none flex-col gap-4">
                    <app-table
                        [columns]="columns"
                        [data]="users()"
                        [loading]="isLoading() ?? false"
                        [mode]="'server'"
                        [pagination]="true"
                        [total]="total()"
                        [pageSizeOptions]="pageSizeOptions()"
                        [page]="page()"
                        (pageChange)="onPageChange($event)"
                    />
                </div>
            } @else {
                <div>
                    <p>{{ 'user-management.no-results' | translate }}</p>
                </div>
            }
        </ng-container>
    </div>
</div>
